
export enum DisputeShipmentCurrencyCd {
	CAD = 'CAD',
	USD = 'USD'}

